import { useState } from 'react';
import { useTransactionsContext } from '../providers';
import { useEthers } from './useEthers';
export function connectContractToSigner(contract, options, library) {
    if (contract.signer) {
        return contract;
    }
    if (options === null || options === void 0 ? void 0 : options.signer) {
        return contract.connect(options.signer);
    }
    if (library === null || library === void 0 ? void 0 : library.getSigner()) {
        return contract.connect(library.getSigner());
    }
    throw new TypeError('No signer available in contract, options or library');
}
export function useContractFunction(contract, functionName, options) {
    const [state, setState] = useState({ status: 'None' });
    const { addTransaction } = useTransactionsContext();
    const { library, chainId } = useEthers();
    let transaction;
    const send = async (...args) => {
        var _a;
        if (!chainId) {
            return;
        }
        const contractWithSigner = connectContractToSigner(contract, options, library);
        try {
            transaction = await contractWithSigner[functionName](...args);
            setState({ transaction, status: 'Mining', chainId });
            addTransaction({
                transaction,
                submittedAt: Date.now(),
                transactionName: options === null || options === void 0 ? void 0 : options.transactionName,
            });
            const receipt = await transaction.wait();
            setState({ receipt, transaction, status: 'Success', chainId });
        }
        catch (e) {
            const errorMessage = (_a = e.reason) !== null && _a !== void 0 ? _a : e.message;
            if (transaction) {
                setState({ status: 'Fail', transaction, receipt: e.receipt, errorMessage, chainId });
            }
            else {
                setState({ status: 'Exception', errorMessage, chainId });
            }
        }
    };
    return { send, state };
}
//# sourceMappingURL=useContractFunction.js.map